import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import ContainerComponent from '../../helpers/components/container.component';
import './face_config.css';
import './ticket.css';
import ListLayout from './components/list_layout';

const FaceConfig = () => {
    const { token } = useParams();

    //get query params
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const page = queryParams.get('page');
    const c = queryParams.get('c');
    const tt = queryParams.get('tt');
    const is_salt = queryParams.get('is_salt');

    return (
        <>
            <ContainerComponent span={16} top={20} bottom={20}>
                <ListLayout token={token} page={page} hash={c} tt={tt} is_salt={is_salt} />
            </ContainerComponent>
        </>
    );
}

export default FaceConfig;